// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72016 ? "fc22d32c" : chunkId) + "." + {"9797":"95a1a230817b468d","53348":"9971fcaa01ac9d14","59009":"744503657f7bc474","72016":"7418f537f4cd4b02"}[chunkId] + ".js";
};